<template>
	<div class="width-100 height-100 flex-centerize flex-column">
		<AnemicButton @click="button.onClick" v-for="button in filteredButtonsList" :key="button.icon" class="empty-state-button mb-5" tile>
			<div class="display-flex flex-row flex-align-center flex-justify-space-between width-100">
				<div class="display-flex flex-row flex-align-center">
					<div class="icon-card flex-centerize mr-5">
						<SIcon :name="button.icon" :width="25" :height="25" />
					</div>
					<div class="display-flex flex-column flex-align-start">
						<h3 class="button-title">{{ button.title }}</h3>
						<div class="button-description mt-1">{{ button.description }}</div>
					</div>
				</div>
				<v-icon class="chevron">mdi-chevron-right</v-icon>
			</div>
		</AnemicButton>
	</div>
</template>
<script>
import { setIsGuidedTutorialOn } from '@/store/modules/onboarding/actions';
import { setShowInspirationCenter } from '@/store/modules/appLayout/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { isInspirationCenterEnabled } from '@/store/modules/featureFlags/getters';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

const VIDEO_URL = 'https://www.loom.com/embed/71e689c160cf4babbb3f2cb018c35b60';

export default {
	name: 'FlowsListEmptyState',
	computed: {
		...mapGettersShorthand({ isInspirationCenterEnabled }),
		filteredButtonsList() {
			return this.emptyStateButtons.filter((button) => !button.hidden);
		},
		emptyStateButtons() {
			return [
				{
					title: 'Get inspired',
					onClick: this.onGetInspired,
					icon: 'empty-state-get-inspired',
					hidden: !this.isInspirationCenterEnabled,
					description: 'Not sure what to build? Open the idea center',
				},
				{
					icon: 'empty-state-learn',
					title: 'Learn the basics',
					onClick: this.onLearn,
					description: 'Watch a quick 4 minute overview',
				},
				{
					title: 'Build with a tutorial',
					onClick: this.onBuildWithTutorial,
					icon: 'empty-state-build-with-tutorial',
					description: 'Get your first feature with a step-by-step guided tutorial',
				},
			];
		},
	},
	methods: {
		...mapActionsShorthand({ setShowInspirationCenter, setIsGuidedTutorialOn }),
		onGetInspired() {
			this.setShowInspirationCenter({ showInspirationCenter: true });
		},
		onLearn() {
			AppDialogManagerService.openIFrameDialog({ iframeUrl: this.VIDEO_URL });
		},
		onBuildWithTutorial() {
			this.setIsGuidedTutorialOn(true);
		},
	},
	data() {
		return {
			VIDEO_URL,
		};
	},
};
</script>
<style scoped lang="scss">
.empty-state-button {
	width: 100% !important;
	height: 86px !important;
	max-width: 540px !important;
	font-weight: normal !important;
	border-radius: 11px !important;
	background: var(--white) !important;
	padding: 18px 22px 18px 14px !important;
	border: 1px solid #f0f0f3 !important;
	box-shadow: 0px 3px 26px #00000029 !important;
}
.button-title {
	font-weight: 600;
}
.button-description {
	font-size: 14px;
	color: #182e46;
}
.chevron {
	font-size: 20px;
	color: #8f92a1 !important;
}
.icon-card {
	width: 48px;
	height: 48px;
	border-radius: 11px;
	background: #edecfc;
}
</style>
